// extracted by mini-css-extract-plugin
export default {"align_left":"SidebarAdmin_align_left__8Afv+"};